/* eslint-disable no-case-declarations */
import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const Operators = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_OPERATORS:
      return { ...state, operators: action.value };
    case actions.CITY_OPERATORS:
      const {
        cityIdArr = [],
        searchText = "",
        operatorId = "",
        operatorIdArray = [],
      } = action.value;
      let result = state.operators;
      if (cityIdArr.length > 0) {
        result = result.filter(
          (elem) => cityIdArr.includes(elem.cityId) || elem.operatorId === "promoter",
        );
      }
      if (searchText) {
        result = result.filter((elem) => elem.operatorName.includes(searchText));
      }
      if (operatorId) {
        result = result.filter((elem) => elem.operatorId === operatorId);
      }
      if (operatorIdArray.length > 0) {
        result = result.filter((elem) => operatorIdArray.includes(elem.operatorId));
      }
      return { ...state, cityOperators: result };
    case actions.SELECTED_OPERATOR:
      const selectedOperator = action.value;
      return { ...state, selectedOperator };
    default:
      return state;
  }
};
export default Operators;
